module.exports = __webpack_public_path__ + "static/media/locationimage.97d2b885.svg";